import React, { Component, createRef } from "react";
import OktaSignIn from "@okta/okta-signin-widget";
import logo from "../assets/mlb-okta-logo.png";
import "@okta/okta-signin-widget/css/okta-sign-in.min.css";
import { oktaAuth, OKTA_CALLBACK_PATH } from "../oktaConfig";
import { RouteConstants } from "../constants/RouteConstants";

export default class OktaSignInWidget extends Component {
  widgetContainer = createRef();
  widget = null;

  componentDidMount() {
    if (!oktaAuth.getOriginalUri()) {
      oktaAuth.setOriginalUri(RouteConstants.BASE);
    }

    this.widget = new OktaSignIn({
      baseUrl: this.props.baseUrl,
      clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
      redirectUri: `${window.location.origin}${OKTA_CALLBACK_PATH}`,
      authClient: oktaAuth,
      useClassicEngine: true,
      logo,
      authParams: {
        pkce: false,
        issuer: process.env.REACT_APP_OKTA_ISSUER,
        responseType: ["token", "id_token"],
        scopes: ["openid", "profile", "email"],
      },
    });

    this.widget
      .showSignInAndRedirect({ el: this.widgetContainer.current })
      .catch((err) => {
        console.error("Okta sign-in failed", err);
      });
  }

  componentWillUnmount() {
    if (this.widget) {
      this.widget.remove();
    }
  }

  render() {
    return <div ref={this.widgetContainer} />;
  }
}
